import React from 'react';
import { RadioGroup, Radio, FormHelperText, FormControlLabel, FormControl, FormLabel, Tooltip } from '@mui/material';
import { isMobileSize } from '../../../helpers/functions/functions';
import InfoIcon from '@mui/icons-material/Info';

function RenderRadioGroup({ input, meta: { invalid, touched, error, active }, ...custom }) {
	return (
		<FormControl component="fieldset" error={touched && invalid && !active}>
			<FormLabel component="legend">
				{custom.inputdata.label}{' '}
				{custom.inputdata.infoTooltip && (
					<Tooltip title={custom.inputdata.infoTooltip} placement="right-end" color="secondary">
						<InfoIcon size="small" />
					</Tooltip>
				)}
			</FormLabel>
			<RadioGroup
				{...input}
				id={custom.inputdata.id}
				name={custom.inputdata.name}
				onChange={(event) => {
					input.onChange(event);
					if (typeof custom.inputdata.onChange !== 'undefined') {
						custom.inputdata.onChange(event.target.value);
					}
				}}
				row={typeof custom.inputdata.row !== 'undefined' ? custom.inputdata.row : !isMobileSize()}
				{...custom}
			>
				{custom.inputdata.options.map((option) => (
					<FormControlLabel
						key={option.value}
						value={option.value}
						control={<Radio />}
						label={
							<span
								style={{
									color: option.readonly ? undefined : option.label_color || 'inherit',
								}}
							>
								{option.label}
								{option.readonly && option.tooltip && (
									<Tooltip title={option.tooltip} placement="right">
										<InfoIcon fontSize="small" color="primary" style={{ marginLeft: 4, verticalAlign: 'top' }} />
									</Tooltip>
								)}
							</span>
						}
						disabled={option.readonly}
					/>
				))}
			</RadioGroup>
			<FormHelperText>{touched && !active && error}</FormHelperText>
		</FormControl>
	);
}

export default RenderRadioGroup;
